export default "__VITE_ASSET__IJjpCSxk__"